import { createSvgComponent } from "../../icon/createSvgComponent";
import NavigationArrowOn from "@core/__generated__/icon/figma/navigation-arrow-on.svg";
export default createSvgComponent(NavigationArrowOn);